var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { SharedTiming } from '@lean-body/src/interfaces';
export class TwitterService {
    constructor(apiClient, alertPresenter, localStorage, tracker, navigate) {
        Object.defineProperty(this, "apiClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "alertPresenter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "localStorage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tracker", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "navigate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isAuthorized", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "tweetImgSrc", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tweetCenterImageWidth", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tweetDefaultText", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "shareClickParams", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "showFormDialog", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "loadTwitterAuthorized", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => __awaiter(this, void 0, void 0, function* () {
                if (this.isAuthorized)
                    return;
                // oauth認証済みかどうかをAPIで取得
                this.isAuthorized = yield this.apiClient.confirmTwitterAuthorization();
            })
        });
        Object.defineProperty(this, "loadTwitterAuthorizationURL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => __awaiter(this, void 0, void 0, function* () {
                // oauth認証URLをAPIで取得
                return yield this.apiClient.twitterAuthorization();
            })
        });
        // アクティビティページでバッジダイアログを開いたログをBQへ送信
        Object.defineProperty(this, "sendBqBadgeOpenDialog", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (badge) => {
                // BQログ作成
                this.shareClickParams = { sharedTiming: SharedTiming.collection };
                this.prepareBadge(badge);
                this.tracker.trackTwitterDialogOpen(this.shareClickParams);
            }
        });
        // Twitterシェアボタンのクリックハンドラ（レッスン・プログラム・プレイリスト用）
        Object.defineProperty(this, "onClickShare", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (sharedTiming, lesson, program, playlist) => __awaiter(this, void 0, void 0, function* () {
                yield this.loadTwitterAuthorized();
                // BQログ作成
                this.shareClickParams = { sharedTiming: sharedTiming };
                // ツイートコンテンツの設定
                if (lesson)
                    this.prepareLesson(lesson);
                else if (program)
                    this.prepareProgram(program);
                else if (playlist)
                    this.preparePlaylist(playlist);
                // BQログ送信
                this.tracker.trackTwitterShareClick(this.shareClickParams, this.isAuthorized);
                // まだ認証されていなかったらTwitterの認証ページへリダイレクトする
                this.redirectToTwitterAuthIfNeeded();
                // 認証済みであれば呼び出し元でコールバックが実行される
            })
        });
        // Twitterシェアボタンのクリックハンドラ（バッジ・修了証・ランク用）
        Object.defineProperty(this, "onClickShareForBadgeOrRank", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (imgSrc, centerImageWidth, defaultText, sharedTiming, badge) => __awaiter(this, void 0, void 0, function* () {
                yield this.loadTwitterAuthorized();
                // BQログ作成
                this.shareClickParams = { sharedTiming: sharedTiming };
                // ツイートコンテンツの設定
                if (badge)
                    this.prepareBadge(badge);
                this.tweetImgSrc = imgSrc;
                this.tweetCenterImageWidth = centerImageWidth;
                this.tweetDefaultText = defaultText;
                // BQログ送信
                this.tracker.trackTwitterShareClick(this.shareClickParams, this.isAuthorized);
                // まだ認証されていなかったらTwitterの認証ページへリダイレクトする
                this.redirectToTwitterAuthIfNeeded();
                // 認証済みであれば呼び出し元でコールバックが実行される
            })
        });
        // Twitterシェアボタンのクリックハンドラ（Reward用）
        Object.defineProperty(this, "onClickShareReward", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (reward, sharedTiming) => __awaiter(this, void 0, void 0, function* () {
                yield this.loadTwitterAuthorized();
                this.shareClickParams = { sharedTiming: sharedTiming };
                // まだ認証されていなかったらTwitterの認証ページへリダイレクトする
                this.redirectToTwitterAuthIfNeeded(); // 認証済みであれば呼び出し元でコールバックが実行される
            })
        });
        // Oauth認証後コールバック処理
        Object.defineProperty(this, "onTwitterAuthCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const storageData = this.localStorage.loadTwitterRedirectData;
                const p = new URLSearchParams(location.search);
                if (!p.get('denied')) {
                    // ストレージからデータ取得
                    this.tweetImgSrc = storageData.tweetImgSrc;
                    this.tweetCenterImageWidth = storageData.tweetCenterImageWidth;
                    this.tweetDefaultText = storageData.tweetDefaultText;
                    this.shareClickParams = this.localStorage.loadBqSnsShareClickParams;
                    // リダイレクト後にフォームを表示する
                    this.showFormDialog = true;
                }
                // リダイレクト実行
                this.navigate(storageData.redirectURL);
                // ストレージのデータ削除
                this.localStorage.resetTwitterData();
            }
        });
        // ツイート実行処理
        Object.defineProperty(this, "postTweet", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (text, file) => __awaiter(this, void 0, void 0, function* () {
                const params = {
                    text: text,
                };
                yield this.apiClient
                    .postTweet(params, file)
                    .then(() => {
                    // BQログ送信
                    this.tracker.trackTwitterPostTweetClick(this.shareClickParams);
                    this.alertPresenter.showMessage('ツイートを投稿しました');
                })
                    .catch((err) => {
                    this.alertPresenter.showMessage('ツイートの投稿に失敗しました');
                    // 再度認証情報をサーバから取得させる
                    this.isAuthorized = false;
                    throw err;
                });
            })
        });
        Object.defineProperty(this, "redirectToTwitterAuthIfNeeded", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => __awaiter(this, void 0, void 0, function* () {
                if (this.isAuthorized)
                    return;
                // 認証後のリダイレクトでツイートフォームへ戻ってこれるようにストレージにデータを保存しておく
                const twitterRedirectData = {
                    tweetImgSrc: this.tweetImgSrc,
                    tweetCenterImageWidth: this.tweetCenterImageWidth,
                    tweetDefaultText: this.tweetDefaultText,
                    redirectURL: window.location.pathname,
                };
                this.localStorage.saveBqSnsShareClickParams(this.shareClickParams);
                this.localStorage.saveTwitterRedirectData(twitterRedirectData);
                const url = yield this.loadTwitterAuthorizationURL();
                window.location.href = url;
            })
        });
        Object.defineProperty(this, "prepareLesson", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (lesson) => {
                this.tweetImgSrc = lesson.thumbnailURL;
                this.tweetCenterImageWidth = 0;
                this.tweetDefaultText = `LEAN BODYの『${lesson.name}』 #リーンボディ #LEANBODY`;
                this.shareClickParams.sharedLessonId = lesson.id.toString();
            }
        });
        Object.defineProperty(this, "prepareProgram", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (program) => {
                this.tweetImgSrc = program.thumbnailURL;
                this.tweetCenterImageWidth = 0;
                this.tweetDefaultText = `LEAN BODYの『${program.name}』 #リーンボディ #LEANBODY`;
                this.shareClickParams.sharedProgramId = program.id.toString();
                this.shareClickParams.sharedProgramIsChallenge = !!program.isChallenge;
                this.shareClickParams.sharedProgramIsPlaylist = !!program.isPlaylist;
            }
        });
        Object.defineProperty(this, "preparePlaylist", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (playlist) => {
                this.tweetImgSrc = playlist.thumbnailURL;
                this.tweetCenterImageWidth = 130;
                this.tweetDefaultText = `LEAN BODYの『${playlist.name}』 #リーンボディ #LEANBODY`;
                this.shareClickParams.sharedProgramId = playlist.id.toString();
                this.shareClickParams.sharedProgramIsChallenge = !!playlist.isChallenge;
                this.shareClickParams.sharedProgramIsPlaylist = true;
            }
        });
        Object.defineProperty(this, "prepareBadge", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (badge) => {
                this.shareClickParams.sharedBadgeId = badge.id.toString();
                this.shareClickParams.sharedBadgeType = badge.type;
            }
        });
        this.apiClient = apiClient;
        this.alertPresenter = alertPresenter;
        this.localStorage = localStorage;
        this.tracker = tracker;
        this.navigate = navigate;
    }
}
